import React, { Suspense } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

// components
import Root from './Root';

// lazy load components
const Home = React.lazy(() => import('pages/landings/Home/Home'));
const MedTrade2026 = React.lazy(() => import('pages/landings/MedTrade2026/MedTrade2026'));
const MedTradeBoothMap = React.lazy(() => import('pages/landings/MedTrade2026/MedTradeBoothMap'));
const Careers = React.lazy(() => import('pages/landings/Careers/Careers'));
const JobDetail = React.lazy(() => import('pages/landings/Careers/JobDetail'));
const PrivacyPolicyRedirect = React.lazy(() => import('pages/PrivacyPolicyRedirect'));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    return useRoutes([
        {
            // root route
            path: '/',
            element: <Root />,
        },
        {
            // public routes
            path: '/',
            children: [
                {
                    path: 'home',
                    element: <LoadComponent component={Home} />,
                },
                {
                    path: 'medtrade-2026',
                    element: <LoadComponent component={MedTrade2026} />,
                },
                {
                    path: 'medtrade-2026/booth-map',
                    element: <LoadComponent component={MedTradeBoothMap} />,
                },
                {
                    path: 'careers',
                    element: <LoadComponent component={Careers} />,
                },
                {
                    path: 'careers/:slug',
                    element: <LoadComponent component={JobDetail} />,
                },
                {
                    path: 'privacy-policy',
                    element: <LoadComponent component={PrivacyPolicyRedirect} />,
                },
            ],
        },
    ]);
};

export default AllRoutes;